export default [
    {
        client: "Woodland Park Zoo",
        title: "Woodland Park Zoo",
        slug: 'woodland-park-zoo',
        job: "Southeast Asian Exhibit Audio System",
        date: "August 11, 2015",
        tags: ['case study'],
        content: `
        Woodland Park Zoo is a zoological garden located in the Phinney Ridge neighborhood of Seattle, Washington.
         Woodland Park Zoo has won more Best National Exhibit awards from the Association of Zoos & Aquariums than any other zoological institution except the Bronx Zoo in New York.
          One of the newest immersion exhibits represents Southeast Asian forests. The second and final phase of this exhibit opened in May 2015, featuring new exhibits for sloth bears and Malayan tigers.
           Streamline was hired to upgrade the exhibit with updated digital audio technology. Our work included installing microphones within the exhibit to pick up audio from animal shelters and affixing loudspeakers to glass windows.
         In addition, Streamline assembled and wired the equipment rack for all support AV equipment.
        `,
        photos: [
            require('../../public/assets/images/case-study/woodland/1.jpg'),
            require('../../public/assets/images/case-study/woodland/2.gif'),
            require('../../public/assets/images/case-study/woodland/3.jpg'),
            require('../../public/assets/images/case-study/woodland/4.jpg'),
            require('../../public/assets/images/case-study/woodland/5.jpg')
        ]

    },
    {
        client: "VALVE Corporation",
        title: "VALVE",
        slug: 'valve',
        job: "Custom audio studios and mix suites",
        date: "August 11, 2015",
        tags: ['case study'],
        content: `
        Valve Corporation is an American video game development and digital distribution company headquartered in Bellevue, Washington,. 
        Valve has developed critically acclaimed video game series Half-Life, Portal, and Left 4 Dead.
        Streamline was hired to build and install  custom audio studios and mix/edit suites for Valve.
         Streamline’s work included installing equipment,
        building equipment racks, and pulling and terminating wire for six (6) Valve Edit Rooms,
         a Control Room, a Mix Room (featuring Custom Pelonis loudspeakers and amplifiers), an ADR Room, and a Foley Recording Studio.
        `,
        photos: [
            require('../../public/assets/images/case-study/vavle/1.jpg'),
            require('../../public/assets/images/case-study/vavle/2.jpg'),
            require('../../public/assets/images/case-study/vavle/3.jpg'),
            require('../../public/assets/images/case-study/vavle/4.jpg'),
            
        ]

    },
    {
        client: "EMP SKY CHURCH",
        title: "EMP SKY CHURCH",
        slug: 'emp-sky-church',
        job: "One of the largest indoor HD LED video walls in the world",
        date: "August 11, 2015",
        tags: ['case study'],
        content: `
        Skychurch, located within the Experience Music Project (EMP) museum in Seattle WA, is a Multi-Purpose 
        and Event Venue supporting a mammoth indoor HD LED video wall and state-of-the-art audio and lighting systems.
         Streamline was hired to build out the control booth for a new HD LED video wall. Streamline re-built the equipment 
         racks in the booth, which included mounting and cable dressing for all devices, video jack fields, and routers. In addition, 
         our work also included removing the existing AES router, replacing the AES router with a new router, moving all the SD sources
        to the new HD router, and re-routing all patch panel cabling.
        `,
        photos: [
            require('../../public/assets/images/case-study/emp/1.jpg'),
            require('../../public/assets/images/case-study/emp/2.jpg'),
            require('../../public/assets/images/case-study/emp/3.jpg'),
            require('../../public/assets/images/case-study/emp/4.jpg'),
            
        ]

    },
    {
        client: "SPACE NEEDLE",
        title: "SPACE NEEDLE OBSERVATION DECK",
        slug: 'space-needle-observation-deck',
        job: "Seattle’s largest continuous touchscreen",
        date: "August 11, 2015",
        tags: ['case study'],
        content: `
        The Space Needle is an observation tower located in Seattle, WA. 
        A beloved Seattle icon and the largest tourist attraction in the Northwest,
        the Observation Deck hosts over 1 million visitors each year. In 2014, 
        Streamline was hired by the Space Needle to help “elevate” the customer experience
        on the Observation Deck by installing several interactive kiosks as well as an interactive,
        multi-touch, digital video wall. Streamline worked closely with the Space Needle staff, construction team,
        content developers, and touch screen manufacturers to select the best equipment to withstand the heavy usage
        by visitors and provide maximum visibility and functionality even in direct sunlight. Our work included installing a custom, 
        interactive  video wall consisting of 15 flat panel touch screens, as well as assembling and wiring the equipment racks for all support equipment.
        `,
        photos: [
            require('../../public/assets/images/case-study/space-needle/1.jpg'),
            require('../../public/assets/images/case-study/space-needle/2.jpg'),
            require('../../public/assets/images/case-study/space-needle/3.jpg'),
            require('../../public/assets/images/case-study/space-needle/4.jpg'),
            
        ]

    },
    {
        client: "BENAROYA HALL",
        title: "BENAROYA HALL",
        slug: 'benaroya-hall',
        job: "Home of the Seattle Symphony",
        date: "August 11, 2013",
        tags: ['case study'],
        content: `
        Benaroya Hall, located in downtown Seattle, WA, is the home of the Seattle Symphony. 
        Beneroya Hall has long been recognized for its technology-infused acoustics and award winning
        architecture, and hosts some of the finest performers in the world.  Streamline Solutions,
        in partnership with Carlson Audio, was selected by Benaroya Hall for a major sound system 
        renovations in the S. Mark Taper Foundation Auditorium, the beautiful 2,500 seat hall where most
        of Benaroya’s major performances take place. Streamline replaced all existing speakers and much
        of the existing speaker cables in the auditorium, rebuilt the equipment racks, and delivered new
        full system Auto CAD drawings upon completion of this project in 2013.


        `,
        photos: [
            require('../../public/assets/images/case-study/benaroya-hall/1.jpg'),
            require('../../public/assets/images/case-study/benaroya-hall/2.jpg'),
            require('../../public/assets/images/case-study/benaroya-hall/3.jpg'),
            require('../../public/assets/images/case-study/benaroya-hall/4.jpg'),
            
        ]

    },
    {
        client: "UW HUSKY STADIUM",
        title: "UW HUSKY STADIUM",
        slug: 'uw-husky-stadium',
        job: "Husky Digital Signage Project",
        date: "August 11, 2013",
        tags: ['case study'],
        content: `
        Streamline’s Largest Digital Signage Project to Date! UW Husky Stadium is an outdoor football 
        stadium on the campus of the University of Washington in Seattle, Washington, United States.
         It has been the home of the Washington Huskies of the Pacific-12 Conference since 1920, hosting
          its football games. The stadium recently completed a $280 million renovation, which began in 2011.
           Prior to the 2011-13 renovation, a total capacity of 72,500 made it the largest stadium in the Pacific
            Northwest and the 23rd largest in college football. Streamline was hired to install various digital
             signage and audio systems for the University of Washington Husky Stadium project. The installation
              included the mounting and installation of nearly 750 flat panel displays, the patching and termination
               for approximately 1800 patch points, installing multiple network switches in multiple IDF closets throughout
                the stadium, and the installation of all back-of-house audio support equipment.
        `,
        photos: [
            require('../../public/assets/images/case-study/uw-husky-stadium/1.jpg'),
            require('../../public/assets/images/case-study/uw-husky-stadium/2.jpg'),
            require('../../public/assets/images/case-study/uw-husky-stadium/3.jpg'),
            require('../../public/assets/images/case-study/uw-husky-stadium/4.jpg'),
            
        ]

    },
]